import { Button } from "react-bootstrap"
import { useEffect } from "react"

import { useDeclineInviteMutation } from "../../app/clubsApiSlice"
import useAuth from "../../hooks/useAuth"
import LoadingTextSwap from "../LoadingTextSwap"
import toast from "react-hot-toast"

const DeclineInviteButton = ({ clubId, inviteId, disableButtons, setDisableButtons }) => {
  const { uid } = useAuth()
  const [declineInvite, { isLoading }] = useDeclineInviteMutation()

  useEffect(() => {
    if (isLoading) {
      setDisableButtons(true)
    } else {
      setDisableButtons(false)
    }
  }, [isLoading, setDisableButtons])

  const onClick = async () => {
    try {
      await declineInvite({ clubId, inviteId, uid }).unwrap()

    } catch (error) {
      console.log(error)
      toast.error("An error occured")
    }
  }
  return (
    <Button
      variant=""
      className="bg-white shadow-btn border-light rounded-3 px-3 w-50"
      onClick={onClick}
      disabled={disableButtons}
    >
      <LoadingTextSwap isLoading={isLoading} pulseColor="var(--bs-secondary)">
        Decline
      </LoadingTextSwap>
    </Button>
  )
}

export default DeclineInviteButton